export default __webpack_public_path__ + "static/media/stockmarket.dcfa60c4.JPG";